import * as THREE from 'three';
import { useGLTF } from '@react-three/drei';
import { GLTF } from 'three-stdlib';
import model from './glb/jet_normal_bike-transformed.glb';

type GLTFResult = GLTF & {
  nodes: {
    stand: THREE.Mesh
  }
  materials: {
    mat_justeat_bike: THREE.MeshStandardMaterial
  }
};


export default function Model(props: JSX.IntrinsicElements['group']) {
	const { nodes, materials } = useGLTF(model) as GLTFResult;
	return (
		<group {...props} scale={0.9} dispose={null}>
			<mesh name="stand" geometry={nodes.stand.geometry} material={materials.mat_justeat_bike} />
		</group>
	);
}

// useGLTF.preload(model);
